<ion-toolbar
  [style]="{ '--background': headerColor }"
  mode="ios"
  class="toolbar-1"
>
  <!-- <div style="display: flex; flex-direction: row; align-items: center"> -->
  <div style="display: flex; flex-direction: row">
    <div class="image-container">
      <img [src]="logo" alt="" />
      <div style="display: flex; flex-direction: row; align-items: center">
        <p [style]="{ color: menuColor }">
          {{ modalTitle }}
        </p>
        <span *ngIf="showEvacuation" fill="clear" class="evacuation">
          <ion-icon slot="start" src="./assets/icon/evacuation.svg"></ion-icon>
          Evacuation Mode
        </span>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </div>
</div> -->
  <!-- <div class="wrapper">
    <div class="logo-icon">
      <img [src]="logo" alt="" />
    </div>
    <p [style]="{ color: menuColor }" size="large">
      {{ modalTitle }}

      <span *ngIf="showEvacuation" fill="clear" class="evacuation">
        <ion-icon slot="start" src="./assets/icon/evacuation.svg"></ion-icon>
        Evacuation Mode
      </span>
    </p>
  </div> -->
  <ion-buttons slot="end">
    <ion-button size="small" fill="clear" (click)="onClose()">
      <ion-icon
        class="close-icon"
        slot="icon-only"
        src="./assets/icon/ic_cancel.svg"
      ></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>

<ion-toolbar
  [style]="{ '--background': headerColor }"
  mode="ios"
  *ngIf="modalSubTitle"
  class="toolbar-2"
>
  <p [style]="{ color: menuColor }" size="large">{{ modalSubTitle }}</p>

</ion-toolbar>
